import { API_BASE_URL, authFetch, getHeaders as baseGetHeaders } from './authFetch';

const USERS_PREFIX = `${API_BASE_URL}/api/v1/users`;

function getHeaders(withJson = true): Record<string, string> {
  return baseGetHeaders(withJson);
}

interface WallpaperResponse {
  payload: Record<string, unknown>;
  updated_at: number;
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.json() as Promise<T>;
}

export async function fetchWallpaperFromCloud(): Promise<WallpaperResponse> {
  const res = await authFetch(`${USERS_PREFIX}/me/wallpaper`, {
    headers: getHeaders(),
  });
  return handleResponse<WallpaperResponse>(res);
}

export async function saveWallpaperToCloud(
  payload: unknown,
  updatedAt: number,
  options?: {
    keepalive?: boolean;
  },
): Promise<WallpaperResponse> {
  const res = await authFetch(`${USERS_PREFIX}/me/wallpaper`, {
    method: 'PUT',
    headers: getHeaders(),
    keepalive: Boolean(options?.keepalive),
    body: JSON.stringify({
      payload,
      updated_at: updatedAt,
    }),
  });
  return handleResponse<WallpaperResponse>(res);
}
